import { render } from "./AddNewUnitType.vue?vue&type=template&id=a16d710a&scoped=true"
import script from "./AddNewUnitType.vue?vue&type=script&lang=js"
export * from "./AddNewUnitType.vue?vue&type=script&lang=js"

import "./AddNewUnitType.vue?vue&type=style&index=0&id=a16d710a&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16d710a"]])

export default __exports__